import {crmApi} from 'sources/api';
import urlWithParams from 'utils/urlWithParams';
import cancelIfSending from 'sources/cancelIfSending';
import {List} from 'immutable';
import CrmAccount from 'records/CrmAccount';

const CrmAccountSource = cancelIfSending({
  searchAccounts(term, cancelConfig) {
    const url = urlWithParams('/search/accounts', {term});
    return crmApi
      .get(url, cancelConfig)
      .then(({data: entities}) => List(entities).map(entity => new CrmAccount(entity)));
  },

  fetchAccount(id) {
    return crmApi.get(`/accounts/${id}`).then(resp => {
      return new CrmAccount(resp.data);
    });
  },
});

export default CrmAccountSource;
